export const GET_APPT_BOOKING_ACCESS_TOKEN = 'apptBooking.tokenAccess.get';
export const GET_APPT_BOOKING_COUNTERS = 'apptBooking.counters.get';

export interface ICounter {
    id: number;
    name: string;
    serviceIds: number[];
    counterLat: number;
    counterLng: number;
    town: string;
    address1: string;
    address2: string;
    phone: string;
    timeslotInterval: number;
    calendars: IApiCalendar[];
    maxAppointmentServices: number;
}

export interface IApiTimeSlots {
    start_date: string;
    end_date: string;
}

export interface IApiCalendar {
    timeslots: IApiTimeSlots[];
}

export type ServiceApptBookingQueries = {
    [GET_APPT_BOOKING_ACCESS_TOKEN]: {};
    [GET_APPT_BOOKING_COUNTERS]: {};
};

export type ServiceApptBookingQueriesResponseType = {
    [GET_APPT_BOOKING_ACCESS_TOKEN]: string;
    [GET_APPT_BOOKING_COUNTERS]: ICounter[];
};
